<template>
<!--  <label style="margin-left: 5px;font-weight: bold">员工信息:</label>-->
    <el-form style="margin: 25px 45px 0 25px;" :model="compensatoryData" label-width="120px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="姓名：" required>
            <el-input v-model="compensatoryData.employee_name" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="工号：" required>
            <el-input v-model="compensatoryData.employee_no" disabled/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="部门：" required>
            <el-cascader v-model="compensatoryData.department_ids" :options="departmentList"
                         :props="optionProps" style="width: 100%" disabled/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="年度：">
            <el-input v-model="compensatoryData.year" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="发放：">
            <el-input v-model="compensatoryData.hours" disabled/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="使用：">
            <el-input v-model="compensatoryData.use_hours" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="余额：">
            <el-input v-model="compensatoryData.balance" disabled/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="有效期：">
            <el-input v-model="compensatoryData.expiring_date" disabled/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
<!--  <label style="margin-left: 5px;font-weight: bold">使用记录:</label>
  <el-tabs v-model="recordData" class="demo-tabs">
    <el-tab-pane label="发放记录" name="first">
      <el-table :data="issueRecordTable" stripe border height="250" style="width: 98%;font-size: 13px;margin: 5px">
        <el-table-column prop="process_id" label="工作流编号" min-width="180" align="center"/>
        <el-table-column prop="start_time" label="加假开始时间" width="250" align="center"/>
        <el-table-column prop="end_time" label="加班结束时间" width="250" align="center"/>
        <el-table-column prop="use_hours" label="加班时长(小时)" width="180" align="center"/>
      </el-table>
    </el-tab-pane>
    <el-tab-pane label="使用记录" name="second">
      <el-table :data="useRecordTable" stripe border height="250" style="width: 98%;font-size: 13px;margin: 5px">
        <el-table-column prop="process_id" label="工作流编号" min-width="120" align="center"/>
        <el-table-column prop="start_time" label="请假开始时间" width="150" align="center"/>
        <el-table-column prop="end_time" label="请假结束时间" width="150" align="center"/>
        <el-table-column prop="use_hours" label="请假时长(小时)" width="130" align="center"/>
        <el-table-column prop="hours_show" label="请假天数" width="110" align="center"/>
        <el-table-column prop="use_hours" label="扣除时长(小时)" width="130" align="center"/>
      </el-table>
    </el-tab-pane>
  </el-tabs>-->
</template>

<script>
export default {
  name: "AttendanceCompensatoryLeave",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      optionProps: {
        value: 'id',
        label: 'name'
      },
      compensatoryData: {},
      recordData:'first',
      departmentList: [],
      leaveTable: [],
      issueRecordTable:[],
      useRecordTable:[],
    };
  },
  methods: {
    //获取部门列表
    async getDepartmentList() {
      this.departmentList = await this.$http('sysUserDepartmentService.getDepartmentData');
    },
    //   回显数据
    async getCompensatoryLeaveData() {
      let params = {id: this.parentData.id}
      let dbLeave = await this.$http('attendanceLeaveService.getCompensatoryLeaveById', params);
      if (dbLeave) {
        this.compensatoryData = dbLeave;
      }
      // await this.getLeaveType();
    },
    //   table获取数据
    async getFirstTable() {
      let params = {
        employee_no: this.parentData.employee_no,
        expiring_date: this.compensatoryData.expiring_date,
      }

      let tbLeave = await this.$http('attendanceLeaveService.getIssueRecordTable', params);
      if (tbLeave) {
        this.issueRecordTable = tbLeave
      }
    },
    async getSecondTable() {
      let params = {
        employee_no: this.parentData.employee_no,
        expiring_date: this.compensatoryData.expiring_date,
        leave_type: 'change_leave'
      }
      console.log("params",params)
      let tbLeave = await this.$http('attendanceLeaveService.getLeaveTable', params);
      if (tbLeave) {
        this.useRecordTable = tbLeave
      }
      console.log("useRecordTable",this.useRecordTable)
    },
    //   获取假别字典
/*    async getLeaveType() {
      let params = {
        id: this.parentData.id,
        leave_type: this.compensatoryData.leave_type
      }
      this.compensatoryData.leave_type = await this.$http('attendanceLeaveService.getLeaveTypeName', params);
    },*/
  },
  created() {
    this.getDepartmentList();
    this.getCompensatoryLeaveData().then(() => {
      this.getFirstTable();
      this.getSecondTable();
    });
  }
}
</script>


<style lang="less" scoped>
.demo-tabs{
  margin:-30px 5px 15px 5px;
  padding: 32px;
  color: #333;
}
.custom-table {
  width: 98%;
  font-size: 12px;
  margin: 5px;
  color: #333;
}
</style>
